import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { MHVoucher } from 'src/app/interfaces/api/voucher';
import { ControllerService } from 'src/app/services/controller.service';
import { VoucherService } from 'src/app/services/voucher.service';

@Component({
  selector: 'app-voucher-card',
  templateUrl: './voucher-card.component.html',
  styleUrls: ['./voucher-card.component.scss'],
})
export class VoucherCardComponent implements OnInit {
  @Input() isLoading: boolean;
  @Input() data: MHVoucher;

  constructor(
    private navController: NavController,
    private controllerService: ControllerService,
    private voucherService: VoucherService,
  ) { }

  ngOnInit() { }

  claimVoucher(idVoucher: number) {
    // console.log(idVoucher)
    this.voucherService.takeVoucher(idVoucher)
      .subscribe({
        next: async (res) => {
          await this.controllerService.presentToast(
            {
              color: 'primary',
              duration: 3000,
              message: res.message,
            },
            true,
          );
        },
        error: async (err) => {
          console.log(err);
        },
      });
  }

  checkDate() {
    return new Date(this.data.take_start_at).getFullYear() === new Date(this.data.take_end_at).getFullYear();
  }
}
